<script>
import Vue from 'vue';
import {mapState, mapGetters} from 'vuex';

export default Vue.extend({
    filters: {
        percentage(string) {
            return string + ' %'
        }
    },
    computed: {
        ...mapState({
            priceGroups: state => state.contract.contract.item.prices.priceGroups
        }),
        ...mapGetters({
            getContractCollapseObject: 'contract/getContractCollapseObject'
        })
    },
    created() {
        this.collapseObject = this.getContractCollapseObject;
    },
    methods: {
        collapse(obj) {
            if (obj.hasOwnProperty('accommodationIndex')) {
                for(let i = 0; i < this.collapseObject[obj.priceGroupIndex].sites[obj.siteIndex].accommodations.length; i++) {
                    this.collapseObject[obj.priceGroupIndex].sites[obj.siteIndex].accommodations[i] = !(i === obj.accommodationIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('accommodation_' + obj.accommodationIndex).scrollIntoView();}, 10)
                }
            } else if (obj.hasOwnProperty('siteIndex')) {
                for(let i = 0; i < this.collapseObject[obj.priceGroupIndex].sites.length; i++) {
                    this.collapseObject[obj.priceGroupIndex].sites[i].collapse = !(i === obj.siteIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('site_' + obj.siteIndex).scrollIntoView();}, 10)
                }
            } else {
                for(let i = 0; i < this.collapseObject.length; i++) {
                    this.collapseObject[i].collapse = !(i === obj.priceGroupIndex);
                    // Use the timeout to ensure that the element is collapsed
                    setTimeout(() => {document.getElementById('priceGroup_' + obj.priceGroupIndex).scrollIntoView();}, 10)
                }
            }
            this.$forceUpdate();
        }
    },
});
</script>
<template>
    <div class="contract-form-price">
        <div class="contract-form-price__content">
            <div class="contract-form-price__header">
                <div class="contract-form-price__heading">
                    {{ $t('contract.form.prices.header.heading') }}
                </div>
            </div>
            <div class="contract-form-price__body">
                <div class="contract-form-price__items">
                    <div v-for="(priceGroup, priceGroupIndex) in priceGroups" :id="'priceGroup_' + priceGroupIndex" :key="'priceGroup_' + priceGroupIndex" class="contract-form-price__item contract-form-price__item-price">
                        <div :class="{'contract-form-price__price-header--collapsed': collapseObject[priceGroupIndex].collapse}" class="contract-form-price__price-header" @click="collapse({priceGroupIndex: priceGroupIndex})">
                            <span>{{ $t('contract.form.prices.setting.priceType.' + priceGroup.priceType) }} > </span>
                            <span>{{ $t('contract.form.prices.setting.pricePr.' + priceGroup.pricePr) }} > </span>
                            <span>{{ $t('contract.form.prices.setting.grossOrNet.' + priceGroup.grossOrNet) }}</span>
                        </div>
                        <div v-if="!collapseObject[priceGroupIndex].collapse">
                            <div v-for="(site, siteIndex) in priceGroup.sites" :id="'site_' + siteIndex" :key="'site_' + siteIndex" class="contract-form-price__item contract-form-price__item-site">
                                <div :class="{'contract-form-price__item-header--collapsed': collapseObject[priceGroupIndex].sites[siteIndex].collapse}" class="contract-form-price__item-header" @click="collapse({priceGroupIndex: priceGroupIndex, siteIndex: siteIndex})">
                                    {{ site.name }}
                                </div>
                                <div v-if="!collapseObject[priceGroupIndex].sites[siteIndex].collapse">
                                    <div v-for="(accommodation, accommodationIndex) in site.accommodations" :id="'accommodation_' + accommodationIndex" :key="'accommodation_' + accommodationIndex" class="contract-form-price__item contract-form-price__item-accommodation">
                                        <div :class="{'contract-form-price__item-label--collapsed': collapseObject[priceGroupIndex].sites[siteIndex].accommodations[accommodationIndex]}" class="contract-form-price__item-label" @click="collapse({priceGroupIndex: priceGroupIndex, siteIndex: siteIndex, accommodationIndex: accommodationIndex})">
                                            {{ accommodation.name }}
                                        </div>
                                        <div v-if="!collapseObject[priceGroupIndex].sites[siteIndex].accommodations[accommodationIndex]">
                                            <div v-for="(price, index) in accommodation.prices" :key="'price_' + index" class="contract-form-price__item contract-form-price__accommodation-row">
                                                <div class="contract-form-price__row-item">
                                                    <div class="contract-form-price__row-label">{{ $t('contract.form.prices.startDate') }}</div>
                                                    <div v-if="price.startDate" class="contract-form-price__item-date">{{ price.startDate | moment('DD/MM/YYYY') }}</div>
                                                </div>
                                                <div class="contract-form-price__row-item">
                                                    <div class="contract-form-price__row-label">{{ $t('contract.form.prices.endDate') }}</div>
                                                    <div v-if="price.endDate" class="contract-form-price__item-date">{{ price.endDate | moment('DD/MM/YYYY') }}</div>
                                                </div>
                                                <div class="contract-form-price__row-item">
                                                    <div class="contract-form-price__row-label">{{ $t('contract.form.prices.price') }}</div>
                                                    <div v-if="price.price" class="contract-form-price__item-price">{{ price.price }}</div>
                                                </div>
                                                <div :class="{'contract-form-price__row-item--inactive': priceGroup.grossOrNet === 'net'}" class="contract-form-price__row-item">
                                                    <div class="contract-form-price__row-label">{{ $t('contract.form.prices.commission') }}</div>
                                                    <div v-if="price.commission && priceGroup.grossOrNet !== 'net'" class="contract-form-price__item-commission">
                                                        {{ price.commission | percentage }}
                                                    </div>
                                                    <div v-if="!price.commission && priceGroup.grossOrNet === 'net'" class="contract-form-price__item-commission">
                                                        {{ $t('contract.form.prices.setting.grossOrNet.' + priceGroup.grossOrNet) }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="priceGroups.length === 0" class="contract-form-site__no-content">
                <i class="fa fa-bullhorn"/>
                <div class="manage-allocation-list__no-content-message">{{ $t('contract.form.prices.noContent') }}</div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormPrice/ContractFormPrice.vue